import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

import { ErrorPageContent } from '../../error/ErrorPage';
import { useLoginErrorPageViewModel } from './useLoginErrorPageViewModel';
import { LoginErrorPageViewModel } from './viewModel';

export function LoginErrorPage({ onLogin: handleLogin }: LoginErrorPageViewModel) {
  const t = useTranslate();
  return (
    <ErrorPageContent
      title={t('telehealth-core:errorsCore.unableToLogIn')}
      subtitle={t('telehealth-core:errorsCore.pleaseTryLoggingInAgain')}
    >
      <Button onClick={handleLogin}>{t('telehealth-core:core.logIn')}</Button>
    </ErrorPageContent>
  );
}

export function LoginErrorPageWrapper() {
  const props = useLoginErrorPageViewModel();

  return <LoginErrorPage {...props} />;
}
